import React from 'react'
import styled from 'styled-components'
import DomiciliationReport from './DomiciliationReport'

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`

const ReportContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
`

const TitleContainer = styled.div`
  width: 100%;
  padding: 0 30px 30px 30px;
  box-sizing: border-box;
  display: flex;
`

const DomiciliationReports = ({ match }) => (
  <Container>
    <TitleContainer>
      <h1>Domiciliaciones</h1>
    </TitleContainer>
    <ReportContainer>
      <DomiciliationReport match={match} />
    </ReportContainer>
  </Container>
)

export default DomiciliationReports



// WEBPACK FOOTER //
// ./src/Containers/Reports/DomiciliationReports.jsx